import { NgIf } from '@angular/common';
import { Component, ComponentRef, Injector, Input, NgZone, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { MonitoringService } from '../../core/error-handler/monitoring.service';

@Component({
  imports: [NgIf],
  selector: 'app-widget-wrapper',
  template: `
    <ng-container *ngIf="!hasError; else fallback"></ng-container>
    <ng-template #fallback>
      <div class="widget-error">Failed to load this widget</div>
    </ng-template>
  `,
})
export class WidgetWrapperComponent implements OnInit, OnDestroy {
  @Input() component!: any;
  @Input() injector!: Injector;

  public hasError = false;
  private cmpRef?: ComponentRef<any>;

  constructor(
    private zone: NgZone,
    private vcr: ViewContainerRef,
    private readonly monitoringService: MonitoringService,
  ) {}

  public ngOnInit(): void {
    try {
      this.zone.runGuarded(() => {
        this.cmpRef =this.vcr.createComponent(this.component, { injector: this.injector });
      });
    } catch (e: unknown) {
      this.hasError = true;
      this.monitoringService.logException(e as Error);
    }
  }

  public ngOnDestroy(): void {
    this.cmpRef?.destroy();
  }
}
